import {
  NEWSLETTER_ADMIN_PAGE_URL,
  NEWSLETTER_PAGE_URL,
  BOOKING_PAGE_URL,
  BOOKING_ADMIN_PAGE_URL,
  ABOUT_PAGE_URL,
  CONTACT_PAGE_URL,
  EXTRA_LINKS_URL,
  FAQS_PAGE_URL,
  GALLERY_PAGE_URL,
  HOME_PAGE_URL,
  ONLINE_SESSIONS_URL,
  RATES_AND_TRIBUTES_URL,
  REAL_TIME_URL,
} from '../Routes';

export const getNavLinkItemsArray = (user) => [
  { path: HOME_PAGE_URL, label: 'Home' },
  { path: ABOUT_PAGE_URL, label: 'About Me' },
  {
    label: 'Sessions',
    subpages: [
      { path: REAL_TIME_URL, label: 'Real Time' },
      { path: ONLINE_SESSIONS_URL, label: 'Online Sessions' },
      { path: RATES_AND_TRIBUTES_URL, label: 'Rates and Tributes' },
    ],
  },
  { path: GALLERY_PAGE_URL, label: 'Gallery' },
  { path: CONTACT_PAGE_URL, label: 'Contact' },
  { path: BOOKING_PAGE_URL, label: 'Booking' },
  { path: NEWSLETTER_PAGE_URL, label: 'Newsletter' },
  { path: FAQS_PAGE_URL, label: 'FAQs' },
  { path: EXTRA_LINKS_URL, label: 'Extra Links' },
  ...(user?.role === 'ADMIN' || user?.role === 'DEVELOPER'
    ? [
        {
          label: 'Admin',
          subpages: [
            { path: BOOKING_ADMIN_PAGE_URL, label: 'Booking' },
            { path: NEWSLETTER_ADMIN_PAGE_URL, label: 'Newsletter' },
          ],
        },
      ]
    : []),
];
